import React from 'react'

import Button, { ButtonProps } from './Button'

const IconButton: React.FC<ButtonProps> = ({ size = 20, ...rest }) => (
  <Button size={size} css={{ backgroundColor: 'transparent' }} {...rest} />
)

export default IconButton
